import type { SVGProps } from 'react';

import { forwardRef } from 'react';

export type IconProps = SVGProps<SVGSVGElement> & { title?: string };

// Decorative unless it is named (a title, aria-label or aria-labelledby): an icon beside text is
// read once, by the text, and a named one is announced as an image.
export const createIcon = (name: string, viewBox: string, path: string, size: number) => {
  const Icon = forwardRef<SVGSVGElement, IconProps>(({ title, ...props }, ref) => {
    const named = Boolean(title || props['aria-label'] || props['aria-labelledby']);

    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox={viewBox}
        width={size}
        height={size}
        fill="currentColor"
        focusable="false"
        aria-hidden={named ? undefined : true}
        role={named ? 'img' : undefined}
        {...props}
      >
        {title ? <title>{title}</title> : null}
        <path d={path} />
      </svg>
    );
  });
  Icon.displayName = `Icon${name}`;

  return Icon;
};
